module.exports = __webpack_public_path__ + "img/access_analysis.2ffa9cbe.png";